/**
 * Restarts the app as whoever is signed in now. A full reload rather than cache invalidation: an
 * identity change swaps the session, permissions, active workspace and impersonation state at
 * once, and refetching in place left pages on stale pre-switch state.
 *
 * A caller's `destination` replaces the URL before the reload instead of being `assign()`ed, so
 * every identity restart reloads the current URL. Two restarts that race — an explicit logout and
 * `AuthIdentityBoundary` reacting to the same session change — then land on the same page, where a
 * later `reload()` would cancel a pending `assign()`.
 */
export function reloadAfterIdentityChange(destination?: string): void {
  if (destination !== undefined) window.history.replaceState(null, "", destination);
  window.location.reload();
}
